import React from 'react'

import { Grid } from '@mui/material'
import CustomerMetricsCharts from 'features/customers/components/metrics/CustomerMetricsCharts'
import CustomerMetricsWorkflows from 'features/customers/components/metrics/CustomerMetricsWorkflows'

const CustomerMetrics = () => {
  return (
    <Grid container spacing={2}>
      <Grid
        size={{
          md: 3,
        }}>
        <CustomerMetricsWorkflows />
      </Grid>
      <Grid
        size={{
          md: 9,
        }}>
        <CustomerMetricsCharts />
      </Grid>
    </Grid>
  )
}

export default CustomerMetrics
